/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScanSessionResultModel } from '../../models/scan-session-result-model';

export interface ScanSessionResultSessionIdGet$Params {

/**
 * The unique identifier of the scan session
 */
  sessionId: string;
}

export function scanSessionResultSessionIdGet(http: HttpClient, rootUrl: string, params: ScanSessionResultSessionIdGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<ScanSessionResultModel>> {
  const rb = new RequestBuilder(rootUrl, scanSessionResultSessionIdGet.PATH, 'get');
  if (params) {
    rb.path('sessionId', params.sessionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<ScanSessionResultModel>;
    })
  );
}

scanSessionResultSessionIdGet.PATH = '/Scan/SessionResult/{sessionId}';
